import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    path: '',
  },
  mutations: {
    setPath(state, payload) {
      state.path = payload;
    },
  },
  actions: {
    
  },
  getters: {
    isLogin: state => !!state.userInfo
  }
});